import React, { useContext, useEffect, useState } from 'react';
import { LogoLoading } from 'ensightful-koala-ui';
import moment from 'moment';
import { styled } from '@mui/material';
import uuid from 'uuid';

import { useSnackbar } from 'contexts/snackbar';
import { useTask } from 'contexts/task';
import { useUser2 } from 'contexts/user2';
import { useViewport } from 'contexts/viewport';
import { IndividualAnalytics, WorkloadAnalytics } from 'components/molecules/Analytics';
import ZeroSumGameTable from 'components/organisms/PeerEvaluation/ZeroSumGameTable';
import {
    RubricGiven,
    RubricReceived,
    ZeroSumGiven,
    ZeroSumReceived,
} from 'components/organisms/PeerEvaluation/PeerEvaluationComponents';
import ResourceSection from 'components/organisms/PeerEvaluation/ResourceSection';
import { PageContext } from 'pages/PeerEvaluation/PageProvider';
import courseRequests from 'services/course';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    CompletionButton,
    Dialog,
    Divider,
    Icon,
    IconButton,
    RubricTable,
    Stack,
    Tabs,
    Tag,
    Text,
} from 'shell/components';
import { getAnalyticsStats, getHTMLCharacterCount, getUserPreferredFullName } from 'utils/helper';

const dummyPeerEvaluation = {
    title: 'Final Peer Evaluation',
    details: 'This is where the assignment "details" you have provided will appear for students',
    resources: [],
    rubric_data: [
        {
            id: 'id1',
            title: 'Communication',
            description: '',
            options: [
                {
                    id: 'op1',
                    rate: '10',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
                {
                    id: 'op2',
                    rate: '8',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
                {
                    id: 'op3',
                    rate: '6',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
                {
                    id: 'op4',
                    rate: '4',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
                {
                    id: 'op5',
                    rate: '2',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
                {
                    id: 'op6',
                    rate: '0',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
            ],
        },
        {
            id: 'id2',
            title: 'Collaboration',
            description: '',
            options: [
                {
                    id: 'op21',
                    rate: '10',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
                {
                    id: 'op22',
                    rate: '0',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
            ],
        },
        {
            id: 'id3',
            title: 'Communication',
            description: '',
            options: [
                {
                    id: 'op31',
                    rate: '10',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
                {
                    id: 'op32',
                    rate: '8',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
                {
                    id: 'op33',
                    rate: '6',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
                {
                    id: 'op34',
                    rate: '4',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
                {
                    id: 'op35',
                    rate: '2',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
                {
                    id: 'op36',
                    rate: '0',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
            ],
        },
        {
            id: 'id4',
            title: 'Project Management Extra Long Title',
            description: '',
            options: [
                {
                    id: 'op41',
                    rate: '10',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
                {
                    id: 'op42',
                    rate: '8',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
                {
                    id: 'op43',
                    rate: '6',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
                {
                    id: 'op44',
                    rate: '4',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
                {
                    id: 'op45',
                    rate: '2',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
                {
                    id: 'op46',
                    rate: '0',
                    title: 'Full Marks',
                    description:
                        'Provided more than 3 arguments in support of hypothesis. Arguments were supported with more than one citation. Writer incorporated their own opinions in a storytelling fashion. All research was done via reputable sources.',
                },
            ],
        },
    ],
};

const dummy_accounts = [
    {
        owner_account_id: 'dummy_1',
        first_name: 'Georgina',
        last_name: 'Watson',
    },
    {
        owner_account_id: 'dummy_2',
        first_name: 'Louisa',
        last_name: 'Kirk',
    },
    {
        owner_account_id: 'dummy_3',
        first_name: 'Johnny',
        last_name: 'Walsh',
    },
    {
        owner_account_id: 'dummy_4',
        first_name: 'Quilin',
        last_name: 'Yang',
    },
];

const dummy_individual_progress = {
    dummy_1: { completedPoints: 11, totalPoints: 30, percentage: 31 },
    dummy_2: { completedPoints: 4, totalPoints: 10, percentage: 40 },
    dummy_3: { completedPoints: 36, totalPoints: 60, percentage: 60 },
    dummy_4: { completedPoints: 64, totalPoints: 80, percentage: 79 },
};

const dummy_workload_stats = {
    dummy_1: { contributionPercentage: 17, totalPoints: 30 },
    dummy_2: { contributionPercentage: 6, totalPoints: 10 },
    dummy_3: { contributionPercentage: 33, totalPoints: 60 },
    dummy_4: { contributionPercentage: 44, totalPoints: 80 },
    unassigned: { contributionPercentage: 0, totalPoints: 0 },
};

const getRubricErrors = (rubricData, submissionData) => {
    let reduceErrors = {};
    let hasError = false;
    reduceErrors = Object.values(rubricData)?.reduce((errors, criterion) => {
        const userSelectedRate = submissionData?.find(
            (userSelectedCriterion) => userSelectedCriterion.id === criterion.id
        )?.selected_rate_id;
        if (!userSelectedRate) {
            errors = { ...errors, [criterion.id]: true };
            hasError = true;
        }
        return errors;
    }, {});
    return { errors: reduceErrors, hasError };
};

const StudentEvaluation = ({ demo = false, handleBack }) => {
    const { device } = useViewport();
    const { message } = useSnackbar();
    const { currentGroupAccountUsers = [] } = useUser2();
    const {
        auth,
        submissionLoading,
        submissions,
        studentStep,
        setStudentStep,
        form,
        currentPeerEvaluationId,
        currentPeerEvaluation,
        selectedPeerEvaluation,
        setSelectedPeerEvaluation,
        submissionData,
        setSubmissionData,
        isEditing,
        setIsEditing,
        updateSubmission,
        createSubmission,

        STUDENT_STEPS,
    } = useContext(PageContext);
    const { taskList, subtaskList } = useTask();

    const [loading, setLoading] = useState(false);
    const [confirmationDialog, setConfirmationDialog] = useState(false);
    const [assignedPercentage, setAssignedPercentage] = useState(0);

    const [evaluationErrors, setEvaluationErrors] = useState();

    // Tab
    const [defaultRoute, setDefaultRoute] = useState('questions');

    const handleBackButton = () => {
        setSelectedPeerEvaluation({});
        setStudentStep(STUDENT_STEPS.START);
        return handleBack();
    };

    const renderTitleOption = () => {
        if (selectedPeerEvaluation?.student_submission) {
            return studentStep === STUDENT_STEPS.START ? (
                <Tag type={'submission'} value={'submitted'} />
            ) : (
                studentStep !== STUDENT_STEPS.RESULT && !selectedPeerEvaluation?.is_released && !isEditing && (
                    <Button variant={'primary'} onClick={() => handleEdit()}>
                        Edit
                    </Button>
                )
            );
        }
    };

    const handleInputs = (accountId, key, value) => {
        return setSubmissionData((submission) => ({
            ...submission,
            [accountId]: { ...submission?.[accountId], [key]: value },
        }));
    };

    const handleRubricInputs = (accountId, key, value) => {
        if (demo) return;
        const constructSubmission = currentPeerEvaluation.rubric_data.map((row) => {
            if (row.id === key) {
                const findRow = currentPeerEvaluation.rubric_data.find((orgRow) => orgRow.id === key);
                const findRate = findRow.options.find((option) => option.id === value);
                return {
                    selected_rate_id: findRate.id,
                    id: findRow.id,
                    options: findRow.options,
                };
            } else {
                const findExistingData = submissionData?.[accountId]?.rubric_data?.find(
                    (submittedRow) => row.id === submittedRow.id
                );
                if (findExistingData) {
                    return findExistingData;
                } else {
                    return row;
                }
            }
        });
        return setSubmissionData((submission) => ({
            ...submission,
            [accountId]: { ...submission?.[accountId], rubric_data: constructSubmission },
        }));
    };

    const handleValidation = () => {
        let noError = true;
        let count = 0;
        const mapErrors = {};
        let result = true;

        currentGroupAccountUsers.forEach((member) => {
            const key = member.owner_account_id;

            if (!submissionData?.[key]) {
                if (selectedPeerEvaluation?.format === 'rubric') {
                    const rubricErrors = getRubricErrors(selectedPeerEvaluation.rubric_data, []);
                    mapErrors[key] = { ...mapErrors[key], rubric_data: rubricErrors.errors };
                }
                mapErrors[key] = { ...mapErrors[key], rate: true };
                if (
                    selectedPeerEvaluation?.is_comment_required &&
                    parseInt(selectedPeerEvaluation?.min_feedback_length) > 0
                ) {
                    mapErrors[key] = { ...mapErrors[key], details: true };
                }
                result = false;
            } else {
                const submission = submissionData[key];
                if (submission) {
                    if (selectedPeerEvaluation?.format === 'rubric') {
                        const rubricErrors = getRubricErrors(
                            selectedPeerEvaluation.rubric_data,
                            submission?.rubric_data
                        );
                        setEvaluationErrors((prev) => ({
                            ...prev,
                            [key]: {
                                rubric_data: rubricErrors.errors,
                            },
                        }));
                        if (noError) noError = !rubricErrors.hasError;
                    } else {
                        if (!submission || !submission?.rate) {
                            noError = false;
                            setEvaluationErrors((prev) => ({ ...prev, [key]: { ...prev[key], rate: true } }));
                        } else {
                            setEvaluationErrors((prev) => ({ ...prev, [key]: { ...prev[key], rate: false } }));
                        }
                    }
                    if (
                        selectedPeerEvaluation?.is_comment_required &&
                        (getHTMLCharacterCount(submission.details) <
                            parseInt(selectedPeerEvaluation?.min_feedback_length) ||
                            !submission.details)
                    ) {
                        setEvaluationErrors((prev) => ({ ...prev, [key]: { ...prev[key], details: true } }));
                        noError = false;
                    }

                    if (
                        selectedPeerEvaluation?.is_comment_required &&
                        submission.details &&
                        getHTMLCharacterCount(submission.details) >=
                            parseInt(selectedPeerEvaluation?.min_feedback_length)
                    ) {
                        setEvaluationErrors((prev) => ({ ...prev, [key]: { ...prev[key], details: false } }));
                    }

                    if (selectedPeerEvaluation?.format === 'zero-sum' && !submission?.rate) {
                        setEvaluationErrors((prev) => ({ ...prev, [key]: { ...prev[key], rate: true } }));
                        noError = false;
                    }
                    count = count + 1;
                }
            }
        });
        if (!result) {
            setEvaluationErrors((prev) => ({ ...prev, ...mapErrors }));
            return false;
        }

        if (selectedPeerEvaluation?.format === 'zero-sum' && assignedPercentage !== 100) return false;

        if (count < members.length) noError = false;
        return noError;
    };

    const deconstrucRubricData = (submission) => {
        if (!submission) return;
        const rubricData = submission?.rubric_data?.reduce((acc, row) => {
            acc[row.id] = row.selected_rate_id;
            return acc;
        }, {});
        return rubricData;
    };

    const handleUpdate = () => {
        if (!handleValidation()) {
            return message.error('Please check your evaluations');
        }
        if (!selectedPeerEvaluation?.student_submission?.id)
            return message.error('Something went wrong. Please try again.');

        const updatedSubmissionData = {
            id: selectedPeerEvaluation.student_submission.id,
            active: true,
            owner_account_id: auth.owner_account_id,
            course_id: auth.course_id,
            group_id: auth.group_id,
            peer_evaluation_id: currentPeerEvaluationId,
            type: 'peer_evaluation',
            data: submissionData,
        };
        return updateSubmission(updatedSubmissionData);
    };

    const handleSubmit = () => {
        if (!handleValidation()) {
            return message.error('Please check your rates');
        }

        const newSubmissionData = {
            id: uuid.v4(),
            active: true,
            owner_account_id: auth.owner_account_id,
            course_id: auth.course_id,
            group_id: auth.group_id,
            peer_evaluation_id: currentPeerEvaluationId,
            type: 'peer_evaluation',
            data: submissionData,
        };

        return createSubmission(newSubmissionData);
    };

    const handleOpenDialog = () => {
        if (!handleValidation()) return message.error('Please check your submission.');
        setConfirmationDialog(true);
    };

    const handleCloseConfirmationDialog = () => {
        setConfirmationDialog(false);
    };

    const handleConfirmDialog = () => {
        if (selectedPeerEvaluation?.student_submission && isEditing) {
            return handleUpdate();
        }
        return handleSubmit();
    };

    const renderSubmitedRate = () => {
        return members?.map((member) => {
            let findMemberSubmissionRate = null;
            let text = '';
            if (selectedPeerEvaluation.format === 'zero-sum') {
                findMemberSubmissionRate = submissionData?.[member.owner_account_id]?.rate;
                text = findMemberSubmissionRate + '%' || 'No Submission';
            } else if (selectedPeerEvaluation.format === 'rubric') {
                findMemberSubmissionRate = submissionData?.[member.owner_account_id]?.rubric_data?.reduce(
                    (acc, row) => {
                        const findOption = row?.options.find((option) => option.id === row.selected_rate_id);
                        acc = acc + parseInt(findOption?.rate || 0);
                        return acc;
                    },
                    0
                );
                text = findMemberSubmissionRate + 'pts' || 'No Submission';
            }

            return (
                <Text>
                    {`· ${getUserPreferredFullName(member)}: `}
                    <Text component={'span'} color={'primary'}>
                        {text}
                    </Text>
                </Text>
            );
        });
    };

    const renderInitialization = () => {
        let step = STUDENT_STEPS.ZERO_SUM;
        if (selectedPeerEvaluation.format === 'rubric') {
            step = STUDENT_STEPS.RUBRIC;
        }
        if (
            selectedPeerEvaluation.is_released ||
            (selectedPeerEvaluation.release_to_students &&
                selectedPeerEvaluation?.end_on <= new Date().getTime() &&
                selectedPeerEvaluation?.release_on <= new Date().getTime())
        ) {
            step = STUDENT_STEPS.RESULT;
        }
        return (
            <Stack alignItems={'center'} justifyContent={'center'}>
                <Button
                    data-cy={'student-evaluation-button'}
                    variant={'primary'}
                    size={'medium'}
                    onClick={() => {
                        setStudentStep(step);
                        return setDefaultRoute(step === STUDENT_STEPS.RESULT ? 'received' : 'questions');
                    }}
                >
                    {selectedPeerEvaluation?.is_released || selectedPeerEvaluation?.student_submission
                        ? 'View Submission'
                        : 'Start Evaluation'}
                </Button>
            </Stack>
        );
    };

    const renderZeroSum = () => {
        if (!Object.values(selectedPeerEvaluation)?.length) return;
        let isPreviewing = selectedPeerEvaluation?.student_submission && !isEditing;
        return (
            <Stack spacing={7}>
                {members?.map((member) => {
                    return (
                        <ZeroSumGameTable
                            key={member.owner_account_id}
                            isPreviewing={isPreviewing}
                            demo={false}
                            assignedPercentage={assignedPercentage}
                            parentErrors={evaluationErrors?.[member.owner_account_id]}
                            member={member}
                            currentPeerEvaluation={selectedPeerEvaluation}
                            submissionData={submissionData?.[member.owner_account_id]}
                            handleInputChanges={handleInputs}
                        />
                    );
                })}
            </Stack>
        );
    };

    const renderRubric = () => {
        if (!Object.values(selectedPeerEvaluation)?.length) return;
        let isPreviewing = selectedPeerEvaluation?.student_submission && !isEditing;
        return (
            <Stack spacing={7}>
                {members?.map((member, index) => {
                    const desctructedSubmissionData = deconstrucRubricData(submissionData?.[member.owner_account_id]);
                    return (
                        <Stack key={member.owner_account_id} spacing={7}>
                            <RubricTable
                                key={member.owner_account_id}
                                sx={{ width: '100%' }}
                                type={'submit'}
                                data={selectedPeerEvaluation?.rubric_data || {}}
                                disabled={isPreviewing}
                                errors={evaluationErrors?.[member.owner_account_id]?.rubric_data}
                                form={desctructedSubmissionData || {}}
                                name={getUserPreferredFullName(member)}
                                number={index + 1}
                                total={members.length}
                                onChange={(key, value) => handleRubricInputs(member.owner_account_id, key, value)}
                            />
                            <ZeroSumGameTable
                                commentOnly={true}
                                isPreviewing={isPreviewing}
                                parentErrors={evaluationErrors?.[member.owner_account_id]}
                                demo={false}
                                assignedPercentage={0}
                                member={member}
                                currentPeerEvaluation={selectedPeerEvaluation}
                                submissionData={submissionData?.[member.owner_account_id]}
                                handleInputChanges={handleInputs}
                            />
                        </Stack>
                    );
                })}
            </Stack>
        );
    };
    const props = {
        device,
        currentPeerEvaluation: selectedPeerEvaluation,
        selectedStudent: auth.owner_account_id,
        students: currentGroupAccountUsers,
        submissionList: submissions,
    };

    const renderReceived = () => {
        return selectedPeerEvaluation?.format === 'rubric' ? (
            <RubricReceived {...props} />
        ) : (
            <ZeroSumReceived {...props} />
        );
    };

    const renderGiven = () => {
        return selectedPeerEvaluation?.format === 'rubric' ? <RubricGiven {...props} /> : <ZeroSumGiven {...props} />;
    };

    const renderBottomButtons = () => {
        if (demo || (selectedPeerEvaluation?.student_submission && !isEditing) || studentStep === STUDENT_STEPS.RESULT)
            return;
        if (selectedPeerEvaluation?.student_submission && isEditing) {
            return (
                <FooterStack
                    direction={'row'}
                    justifyContent={'flex-end'}
                    spacing={4}
                    visible={studentStep !== STUDENT_STEPS.START}
                >
                    <Button variant={'tertiary'} onClick={handleBack}>
                        Cancel
                    </Button>
                    <Button loading={submissionLoading} variant={'primary'} onClick={() => handleOpenDialog()}>
                        Resubmit
                    </Button>
                </FooterStack>
            );
        }
        return (
            <FooterStack
                direction={'row'}
                justifyContent={'flex-end'}
                spacing={4}
                visible={studentStep !== STUDENT_STEPS.START}
            >
                <Button variant={'tertiary'} onClick={handleBack}>
                    Cancel
                </Button>
                <Button
                    data-cy={'student-evaluation-submit-button'}
                    loading={submissionLoading}
                    variant={'primary'}
                    onClick={() => handleOpenDialog()}
                >
                    Submit
                </Button>
            </FooterStack>
        );
    };

    const renderStep = () => {
        switch (studentStep) {
            case STUDENT_STEPS.START: {
                return renderInitialization();
            }
            case STUDENT_STEPS.ZERO_SUM: {
                return renderZeroSum();
            }
            case STUDENT_STEPS.RUBRIC: {
                return renderRubric();
            }
            default:
                return;
        }
    };

    const renderAnalytics = () => {
        return (
            <UtilStack
                alignItems={'flex-start'}
                divider={<Divider flexItem />}
                spacing={4}
                visible={studentStep !== STUDENT_STEPS.START}
            >
                <Stack spacing={2}>
                    <Text variant={'sh2'}>Evaluations</Text>
                    {members?.map((member, index) => {
                        let checked = submissionData?.[member.owner_account_id]?.rate >= 0;
                        if (selectedPeerEvaluation.format === 'rubric') {
                            checked = submissionData?.[member.owner_account_id]?.rubric_data?.every(
                                (row) => row.selected_rate_id
                            );
                        }
                        return (
                            <Stack key={member.owner_account_id} alignItems={'center'} direction={'row'} spacing={3}>
                                <CompletionButton
                                    aria-label={checked ? 'completed' : 'not completed'}
                                    checked={checked}
                                    label={'Evaluation 1'}
                                />
                                <Text variant={'p2'}>Evaluation {index + 1}</Text>
                            </Stack>
                        );
                    })}
                </Stack>

                <Stack sx={{ width: '100%' }} spacing={4}>
                    <Text variant={'sh2'}>Analytics</Text>
                    <Accordion>
                        <AccordionSummary>
                            <Text variant={'p1'}>Individual Progress</Text>
                        </AccordionSummary>
                        <AccordionDetails>
                            <IndividualAnalytics students={members} stats={individualStat} />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <Accordion>
                            <AccordionSummary>
                                <Text variant={'p1'}>Workload Distribution</Text>
                            </AccordionSummary>
                            <AccordionDetails>
                                <WorkloadAnalytics hideChart={true} students={members} stats={workloadStat} />
                            </AccordionDetails>
                        </Accordion>
                    </Accordion>
                </Stack>
            </UtilStack>
        );
    };

    useEffect(() => {
        if (submissionData) {
            const totalPercentage = Object.values(submissionData).reduce((acc, { rate }) => {
                acc = acc + parseInt(rate || 0);
                return acc;
            }, 0);
            if (totalPercentage < 0 || totalPercentage > 100) message.error('Please check your rates.');
            setAssignedPercentage(totalPercentage);
        }
    }, [submissionData]);

    useEffect(() => {
        if (demo) {
            const dummyPeerEvaluationData = {
                ...dummyPeerEvaluation,
                format: form?.format,
            };
            setSelectedPeerEvaluation(dummyPeerEvaluationData);
        } else {
            if (currentPeerEvaluationId && currentPeerEvaluation) {
                const peerEvaluationData = {
                    ...currentPeerEvaluation,
                    format: currentPeerEvaluation.format.value,
                    start_on: moment(currentPeerEvaluation.start_on),
                    end_on: moment(currentPeerEvaluation.end_on),
                    due_on: moment(currentPeerEvaluation.due_on),
                    release_on: moment(currentPeerEvaluation.release_on),
                };
                if (peerEvaluationData?.resources) {
                    setLoading(true);
                    (async () => {
                        await new Promise(async (resolve, reject) => {
                            const fileIds = peerEvaluationData?.resources
                                ?.filter((resource) => resource.type === 'file')
                                .map((resource) => resource.id);
                            const urlIds = peerEvaluationData?.resources
                                ?.filter((resource) => resource.type === 'url')
                                .map((resource) => resource.id);
                            const files = await courseRequests.listCourseFiles(
                                auth.course_id,
                                JSON.stringify({
                                    type: 'peer-evaluation',
                                    id: { $in: [...fileIds] },
                                })
                            );

                            const sharedUrls = await courseRequests.listCourseSharedUrls(
                                auth.course_id,
                                JSON.stringify({
                                    type: 'peer-evaluation',
                                    id: { $in: [...urlIds] },
                                })
                            );
                            peerEvaluationData.resources = [
                                ...files.map((file) => ({ ...file, type: 'file' })),
                                ...sharedUrls.map((url) => ({ ...url, type: 'link' })),
                            ];
                            setLoading(false);
                            resolve();
                        });
                    })();
                }
                const initEvaluationErrors = currentGroupAccountUsers.reduce((acc, student) => {
                    acc[student.owner_account_id] = {
                        rate: false,
                        details: false,
                    };
                    return acc;
                }, {});
                setEvaluationErrors(initEvaluationErrors);
                setSelectedPeerEvaluation(peerEvaluationData);
                if (!submissionData || Object.values(submissionData)?.length === 0) {
                    setSubmissionData(peerEvaluationData?.student_submission?.data);
                }
            }
        }
    }, [currentPeerEvaluationId, currentPeerEvaluation, setSelectedPeerEvaluation, demo, auth.course_id]);

    const stats = [...(currentGroupAccountUsers || []), { owner_account_id: '' }].reduce((acc, cur) => {
        return {
            ...acc,
            [cur.owner_account_id || 'unassigned']: getAnalyticsStats(
                [...Object.values(taskList.all), ...Object.values(subtaskList)],
                cur.owner_account_id
            ),
        };
    }, {});

    const members = demo ? dummy_accounts : currentGroupAccountUsers;
    const individualStat = demo ? dummy_individual_progress : stats;
    const workloadStat = demo ? dummy_workload_stats : stats;

    const submissionTabList = [
        {
            key: 'received',
            value: 'Received',
            content: renderReceived(),
        },
        {
            key: 'given',
            value: 'Given',
            content: renderGiven(),
        },
    ];

    const tabList = [
        {
            key: 'questions',
            value: 'Questions',
            content: renderStep(),
        },
        {
            key: 'analytics',
            value: 'Analytics',
            content: renderAnalytics(),
        },
    ];

    const handleEdit = () => {
        if (defaultRoute === 'analytics') setDefaultRoute('questions');
        return setIsEditing(true);
    };

    const renderTabs = () => {
        return (
            <Tabs
                aria-label={'select an option in peer evaluation'}
                options={studentStep === STUDENT_STEPS.RESULT ? submissionTabList : tabList}
                selected={defaultRoute}
                onChange={setDefaultRoute}
            />
        );
    };

    if (!selectedPeerEvaluation || loading) return <LogoLoading />;

    return (
        <Box>
            <DesktopBox device={device}>
                <MainBox>
                    <FormStack spacing={5}>
                        <Stack spacing={4}>
                            <IconButton
                                aria-label={'back'}
                                kind={'arrowLeft'}
                                size={'medium'}
                                variant={'square'}
                                onClick={handleBackButton}
                            />
                            <Stack spacing={1}>
                                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                                    <Text variant={'h6'}>{selectedPeerEvaluation.title}</Text>
                                    {renderTitleOption()}
                                </Stack>
                                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                                    <Text variant={'p1'} color={'light'}>
                                        {`Due: ${moment(selectedPeerEvaluation.due_on).format('MMMM D [at] hh:mm a')}`}
                                    </Text>
                                    {selectedPeerEvaluation?.student_submission && (
                                        <Text variant={'p1'} color={'light'}>
                                            {`Submitted: ${moment(
                                                selectedPeerEvaluation.student_submission?.created_on
                                            ).format('MMMM D [at] hh:mm a')}`}
                                        </Text>
                                    )}
                                </Stack>
                            </Stack>
                        </Stack>
                        <Divider spacing={2} />
                        <Stack spacing={1}>
                            <Text variant={'sh2'}>Instructions</Text>
                            <Text rich variant={'p2'}>
                                {selectedPeerEvaluation.details}
                            </Text>
                        </Stack>
                        {selectedPeerEvaluation?.resources?.length > 0 && (
                            <Stack spacing={4} sx={{ marginTop: 4 }}>
                                <Text variant={'p2'} weight={'medium'}>
                                    Resources
                                </Text>
                                <Stack sx={{ display: 'grid', gridTemplateColumns: '50% 50%', gridGap: 2 }}>
                                    <ResourceSection
                                        disabled={false}
                                        isInstructor={false}
                                        resourceList={selectedPeerEvaluation?.resources}
                                        currentAccountId={auth.owner_account_id}
                                    />
                                </Stack>
                            </Stack>
                        )}
                        <SubmissionStack submitted={studentStep === STUDENT_STEPS.RESULT} spacing={8}>
                            {studentStep !== STUDENT_STEPS.START ? renderTabs() : renderInitialization()}
                        </SubmissionStack>
                        {renderBottomButtons()}
                    </FormStack>
                </MainBox>
            </DesktopBox>
            <Dialog open={confirmationDialog} onClose={() => handleCloseConfirmationDialog()}>
                <Stack spacing={7}>
                    <Stack alignItems={'center'} justifyContent={'center'}>
                        <CustomIcon kind={'error'} />
                        <Text color={'primary'}>Double check your submissions</Text>
                    </Stack>
                    <Stack>
                        <Text>You have made the following evaluations:</Text>
                        {renderSubmitedRate()}
                    </Stack>

                    <Stack alignItems={'center'} direction={'row'} justifyContent={'center'}>
                        <Stack alignItems={'center'} direction={'row'} spacing={8}>
                            <Button variant={'tertiary'} onClick={() => handleCloseConfirmationDialog()}>
                                Cancel
                            </Button>
                            <Button
                                data-cy={'student-evaluation-confirm-button'}
                                loading={submissionLoading}
                                variant={'secondary'}
                                onClick={() => handleConfirmDialog()}
                            >
                                Confirm
                            </Button>
                        </Stack>
                    </Stack>
                </Stack>
            </Dialog>
        </Box>
    );
};

const DesktopBox = styled(Box)(({ theme }) => {
    return {
        display: 'block',
        borderRadius: '12px 12px 0 0',
        width: '100%',
        minHeight: 'calc(100vh - 64px - 20px - 58px)',
        background: theme.palette.ensightful.shades[0],
    };
});

const MainBox = styled(Box)(({ theme }) => {
    return {
        padding: theme.spacing(8, 10),
    };
});

const FormStack = styled(Stack)(() => {
    return {};
});

const SubmissionStack = styled(Stack)(({ submitted, theme }) => {
    return submitted
        ? {
              border: `1px solid ${theme.palette.ensightful.neutral[300]}`,
              borderRadius: theme.spacing(1),
          }
        : {};
});

const UtilStack = styled(Stack)(({ visible, theme }) => {
    return {
        display: visible ? 'flex' : 'none',
        padding: theme.spacing(5),
        width: '100%',
    };
});

const FooterStack = styled(Stack)(({ visible }) => {
    return {
        display: visible ? 'flex' : 'none',
    };
});

const CustomIcon = styled(Icon)(({ theme }) => {
    return {
        borderRadius: '50%',
        marginBottom: theme.spacing(2),
        padding: '0.3125rem',
        fontSize: '1.5rem',
        background: theme.palette.ensightful.primary[500],
        color: theme.palette.ensightful.shades[0],
    };
});

export default StudentEvaluation;
